<template>
  <div id="app">
    <header>
      <div class="wrap">
        <a class="logo" @click="$router.push('/')">
         <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="30px" height="30px" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
            viewBox="0 0 80 80"
            t="1634283454810"
            p-id="4319">
            <g>
              <metadata id="CorelCorpID_0Corel-Layer"/>
              <polygon class="fil0" points="29.42,29.42 50.58,29.42 50.58,50.58 29.42,50.58 " p-id="4320"/>
              <polygon class="fil1" points="20.35,44.6 23.69,39.27 61.64,63.02 58.3,68.36 " p-id="4321"/>
              <path class="fil1" d="M59.97 14.24m-13.05 0c0,7.21 5.84,13.06 13.05,13.06 7.21,0 13.06,-5.85 13.06,-13.06 0,-7.2 -5.85,-13.05 -13.06,-13.05 -7.21,0 -13.05,5.85 -13.05,13.05z" p-id="4322"/>
              <path class="fil2" d="M22.01 41.94m-15.97 0c0,8.82 7.15,15.98 15.97,15.98 8.83,0 15.98,-7.16 15.98,-15.98 0,-8.82 -7.15,-15.98 -15.98,-15.98 -8.82,0 -15.97,7.16 -15.97,15.98l0 0z" p-id="4323"/>
              <path class="fil3" d="M40.99 25.96m-6.76 0c0,3.74 3.03,6.76 6.76,6.76 3.74,0 6.76,-3.02 6.76,-6.76 0,-3.73 -3.02,-6.76 -6.76,-6.76 -3.73,0 -6.76,3.03 -6.76,6.76l0 0z" p-id="4324"/>
              <path class="fil1" d="M59.97 65.7m-13.03 0c0,7.2 5.84,13.03 13.03,13.03 7.2,0 13.04,-5.83 13.04,-13.03 0,-7.2 -5.84,-13.03 -13.04,-13.03 -7.19,0 -13.03,5.83 -13.03,13.03l0 0z" p-id="4325"/>
            </g>
          </svg>
          <small>艾维联盟</small>
        </a>
        <div class="menu-box">
          <template v-if="$route.path == '/'">
            <a class="item" href="#flow">推广流程</a>
            <a class="item" href="#our">我们的优势</a>
            <a class="item" href="#partner">合作伙伴</a>
            <a class="item" v-if="$store.state.authInfo.id" @click="$router.push('/dashboard')"><a-icon type="dashboard"></a-icon> 进入管理面板</a>
          </template>
          <a class="item" v-if="!$store.state.authInfo.id" @click="$store.commit('showLoginModal',1)">登录</a>
          <template v-if="$store.state.authInfo.id">
            <a class="item" v-if="$route.path != '/'"><a-icon type="user"></a-icon> {{$store.state.authInfo.nickname}}</a>
            <a class="item" @click="logout"> 退出</a>
          </template>
        </div>
      </div>
    </header>
    <a-config-provider :locale="locale">
      <router-view></router-view>
    </a-config-provider>

    <a-modal v-model="$store.state.loginVisible" :title="null" :closable="null" width="400px" :footer="null" dialog-class="login-modal" :maskStyle="{background:'rgba(0,0,0,0.03)'}" centered>
      <div class="login-box white-wrap">
        <div v-if="$store.state.loginStep == 1">
          <div class="title">登录控制面板</div>
            <a-form >
              <a-form-item >
                <a-input v-model="form.email" placeholder="请输入登录邮箱" size="large">
                  <a-icon slot="prefix" type="user"></a-icon>
                </a-input>
              </a-form-item>
              <a-form-item >
                <a-input type="password" v-model="form.password" placeholder="请输入密码" v-on:keyup.enter="login" size="large">
                  <a-icon slot="prefix" type="lock"></a-icon>
                </a-input>
              </a-form-item>
              <a-form-item class="mt-1">
                <a-button icon="login" class="w100p" type="primary" shape="round" :loading="loading" @click="login" size="large">登录</a-button>
              </a-form-item>
              <a-form-item class="text-right">
                <a @click="$store.state.loginStep = 2">注册成为推广者</a>
              </a-form-item>
            </a-form>
        </div>
        <div v-if="$store.state.loginStep == 2">
          <div class="title">注册成为推广者</div>
            <a-form >
              <a-form-item >
                <a-input v-model="regForm.email" placeholder="请输入邮箱" size="large">
                  <a-icon slot="prefix" type="user"></a-icon>
                </a-input>
                <div class="reg-tips">
                  请填写可正常接收邮件的邮箱，审核结果将会通过该邮箱给您发送通知！
                </div>
              </a-form-item>
              <a-form-item >
                <a-input type="password" v-model="regForm.password" placeholder="请输入密码"  size="large">
                  <a-icon slot="prefix" type="lock"></a-icon>
                </a-input>
              </a-form-item>
              <a-form-item >
                <a-input type="password" v-model="regForm.confirm_password" placeholder="请输入密码" size="large">
                  <a-icon slot="prefix" type="lock"></a-icon>
                </a-input>
              </a-form-item>
              <a-form-item >
                <a-input v-model="regForm.channel" placeholder="请输入推广渠道" size="large">
                  <a-icon slot="prefix" type="share-alt"></a-icon>
                </a-input>
                <div class="reg-tips">
                  请描述您的推广渠道，例如：<br>
                  个人网站（www.xxx.com）<br>
                  微信群（xxx）<br>
                  微信公众号（xxx）...等<br>
                  填写该项更容易通过审核！
                </div>
              </a-form-item>
              <a-form-item class="mt-1">
                <a-button icon="sigin" class="w100p" type="danger" shape="round" :loading="loading" @click="register" size="large">立即注册</a-button>
              </a-form-item>
              <a-form-item class="text-right">
                <a @click="$store.state.loginStep = 1">我是推广者，立即登录</a>
              </a-form-item>
            </a-form>
        </div>
        <div v-if="$store.state.loginStep == 3" class="reg-success-box">
          <img  src="./assets/reg-success.png" alt="">
          <div class="reg-title">恭喜注册成功！</div>
          <div class="reg-desc">请耐心等待客服审核后即可赚取佣金啦！</div>
          <div class="btns">
            <a-button type="primary" shape="round" @click="$store.commit('hideLoginModal')">知道了</a-button>
          </div>
        </div>
      </div>
      
    </a-modal>
    <footer>
      <div class="wrap">
        <div class="item-box">
          <a href="https://www.aiviy.com" target="_blank">艾维商城</a>
          <a href="https://www.aiviy.com/article/4" target="_blank">隐私条款</a>
          <a href="https://www.aiviy.com/contact" target="_blank">帮助</a>
          <a>电话：400-632-8878 </a>
          <a>邮箱：support@aiviysoft.com</a>
        </div>
        <div class="item-box mb-1">
          
        </div>
        <div class="item-box">
          ©2015-2022 Aiviy Inc. All rights reserved. 粤ICP备15093941号粤公网安备 44030702001962号
        </div>
      </div>
    </footer>


  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import helper from './utils/helper';
let self;
export default {
  name: 'App',
  components: {
    
  },
  data(){
    return {
      locale: zhCN,
      loading:false,
      loginVisible:false,
      form:{},
      step:1,
      regForm:{},
    }
  },
  beforeMount(){
    this.$store.dispatch('initAuthInfo')
  },
  mounted(){
    self = this;
    
  },
  methods:{
    logout(){
      this.$http.post('logout').then((res)=>{
        self.$message.success(res.msg);
        helper.setStorage('union-auth-info',{});
        helper.setStorage('union-auth-token','');
        this.$store.dispatch('initAuthInfo');
        self.$router.push('/')
      })
    },
    showLoginModal(){
      this.step = 1;
      this.loginVisible = true;
    },
    login(){
  
      this.loading = true;
      this.$http.post('login',this.form).then((res)=>{
        self.loading = false;
        self.$store.commit('hideLoginModal');
        self.$message.success(res.msg);
        //写入本地缓存
        helper.setStorage('union-auth-token', res.data.auth_token);
        helper.setStorage('union-auth-info', res.data);
        self.$store.dispatch('initAuthInfo');
        self.$router.push('/dashboard')
      }).finally(()=>{
        self.loading = false;
      });
    },
    register(){
      this.loading = true;
      this.$http.post('register',this.regForm).then(()=>{
        self.$store.state.loginStep = 3
      }).finally(()=>{
        self.loading = false;
      });
    }
  }
}
</script>

<style lang='less'>
@import './assets/reset.less';

  html,#app{
    height: 100%;
  }
  body{
    font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    line-height:1.5;
    padding: 0;
    margin: 0;
    font-size: 14px;
    color: @text-color;
    height: 100%;
    background: #1b1c30;
  }
  .page-view{
    height: 100%;
  }
  .wrap{
    width: 1200px;
    margin: 0 auto;
  }
  
  *,:after,:before{
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  button, input, select, textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
  button, html input[type=button], input[type=reset], input[type=submit] {
    -webkit-appearance: button;
    cursor: pointer;
  }
  button, select {
    text-transform: none;
  }
  button {
    overflow: visible;
  }
  div{
    box-sizing: border-box;
  }
  p{
    margin: 0;
  }
  a{
    color: inherit;
    text-decoration: none;
  }
  .fixed{
    overflow: hidden;
  }
  .pull-left{
    float: left;
  }
  .pull-right{
    float: right;
  }
  .text-center{
    text-align: center;
  }
  .text-right{
    text-align: right;
  }
  .text-title{
    font-size: 1.3rem;
  }
  .text-title-large{
    font-size: 1.6rem;
  }

  .text-ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow:ellipsis;
  }
  .text-ellipsis-2{
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .text-ellipsis-3{
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  
  .color-danger{
    color: @error-color;
  }
  .color-success{
    color: @success-color;
  }
  .color-primary{
    color: @primary-color;
  }
  .color-warning{
    color: @warning-color;
  }
  .mt-1{
    margin-top: 1rem!important;
  }
  .lh-2{
    line-height: 2rem;
  }
  .w100p{
    width: 100% !important;
  }

  .form-tips{
    color: @text-color-secondary;
    font-size: 12px;
  }
  .mb-1{
    margin-bottom: 1rem!important;
  }
 
  .small{
    font-size: 12px;
  }
  
  header{
    height: 60px;
    background: #222338;
    
  }
  header .wrap{
    display: flex;
    padding-top: 10px;
  }
  header .logo{
    color: #fff;
    font-size: 18px;
    line-height: 40px;
    font-family:fantasy;
    flex: 1;
  }
  header .logo svg{
    vertical-align: middle;
    margin-right: 10px;
    
  }
  header .logo .fil1 {fill:#25C6FC;fill-rule:nonzero}
  header .logo   .fil3 {fill:#ABE3FF;fill-rule:nonzero}
  header .logo   .fil2 {fill:#F17C67;fill-rule:nonzero}
  header .logo   .fil0 {fill:transparent;fill-rule:nonzero}
  header .menu-box{
    display: flex;
    flex: 2;
    text-align: right;
    color: #fff;
    justify-content: flex-end;
  }
   header .menu-box .item{
     line-height: 40px;
     padding: 0 10px;
     color: rgba(255, 255, 255, 0.7);
   }
   header .menu-box .item:hover{
     color: #fff;
   }
  header .menu-box .avatar{
    height: 30px;
    width: 30px;
    border-radius: 50%;
  }

  footer{
    background: #26273b;
    color: rgba(255, 255, 255, 0.5);
    padding: 60px 0;
  }
  footer .wrap{
 
  }
  footer .wrap .item-box{
    text-align: center;
  }
  footer .wrap .item-box a{
    display: inline-block;
    padding: 1rem;
  }
  /*定义滚动条的轨道*/
  .scroll-panel::-webkit-scrollbar{
      cursor: hand;
      width: 4px;
      height: 4px;
      background-color: #eee;
  }
  /*定义滚动条的轨道，内阴影及圆角*/
  .scroll-panel::-webkit-scrollbar-track{
      border-radius: 2px;
      background-color: transparent;
  }
  /*定义滑块，内阴影及圆角*/
  .scroll-panel::-webkit-scrollbar-thumb{
      /*width: 10px;*/
      height: 20px;
      background-color: #999;
  }

  /* 覆盖antd样式 */
  .ant-modal-title,.ant-modal-close{
    color: rgba(0, 0, 0, 0.75);
  }
  .white .ant-tooltip-inner{
    background: #fff;
    color: rgba(0, 0, 0, 0.75);
  }
  .ant-table-placeholder{
    border-bottom: none;
  }
  .ant-form-item{
    margin-bottom: 14px;
  }
  .ant-message-notice-content{
    color: rgba(0, 0, 0, 0.75);
  }
  .ant-table-tbody > tr:last-child > td{
    border-bottom: none;
  }
  .ant-pagination-item-active{
    background: @primary-color;
  }
  .ant-pagination-item.ant-pagination-item-active a{
    color: #fff;
  }
  .ant-pagination-item-active:hover a{
    color: #fff;
  }
  .ant-tag{
    border-radius: 15px;
    padding: 1px 12px;
    border: none;
  }
  .ant-tag-green{
    color: @success-color;
    background: #d3ffe8;
  }
  
  .ant-input.ghost, .ant-input-group-wrapper.ghost .ant-input {
    background: transparent;
    border-radius: 25px;
    display: inline-block;
    width: auto;
  }
  .ant-input-group-wrapper.ghost{
    width: auto;
    vertical-align: middle;
  }
  .ant-input-group-wrapper.ghost .ant-input{
    border-top-right-radius:0;
    border-bottom-right-radius:0;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
    width: 100%;
  }
  .ant-input-group-wrapper.ghost .ant-input-group-addon{
    background: transparent;
    border-top-right-radius:25px;
    border-bottom-right-radius:25px;
  }

.ant-pagination-prev .ant-pagination-item-link, .ant-pagination-next .ant-pagination-item-link{
  background: transparent;
}
.ant-pagination-item{
  background: transparent;  
}
  .ant-select-selection{
    border-radius: 25px;
    background: transparent;
  }
  .durk.ant-select-dropdown{
    color: @primary-color;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  }
  .durk.ant-select-dropdown .ant-select-dropdown-menu-item{
    color: rgba(0, 0, 0, 0.75);
  }
  .durk.ant-select-dropdown .ant-select-dropdown-menu-item-selected{
    color: #111;
    background: rgba(255, 255, 255, 0.8);
  }
  .white-wrap{
    color: rgba(0, 0, 0, 0.75);
  }
  .white-wrap .ant-form-item-label > label, .white-wrap .ant-form-explain{
    color: rgba(0, 0, 0, 0.75);
  }
  .white-wrap .ant-form-item, .white-wrap .ant-input, .white-wrap .ant-select, .white-wrap .ant-select-dropdown-menu-item, .white-wrap .ant-select-arrow, .white-wrap .ant-input-number{
    color: rgba(0, 0, 0, 0.75);
  }
  .white-wrap.ant-select-dropdown{
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) ;
  }
  .white-wrap .ant-input-affix-wrapper .ant-input-prefix,.white-wrap  .ant-input-affix-wrapper .ant-input-suffix, .white-wrap .ant-input-number-handler{
    color: rgba(0, 0, 0, 0.75);
  }
  .white-wrap .ant-input-number-handler-wrap{
    border-left: 1px solid rgba(0, 0, 0, 0.15);
    border-radius:0 25px 25px 0
  }
  .white-wrap .ant-input-number-handler-down{
    border-top:1px solid rgba(0, 0, 0, 0.15);
  }
  .white-wrap .ant-input-number-handler-up-inner,  .white-wrap .ant-input-number-handler-down-inner{
    color: rgba(0, 0, 0, 0.75);
  }
  .white-wrap .ant-input, .white-wrap .ant-select-selection, .white-wrap .ant-input-number{
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 25px;
  }
  .white-wrap .ant-input.ract-item, .white-wrap .ract-item .ant-select-selection, .white-wrap .ant-input-number{
    border-radius: 5px;
  }
  .ant-btn{
    color: rgba(0, 0, 0, 0.75);
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
  .ant-btn-primary, .ant-btn-danger{
    color: #fff;
    border: none;
  }
  .ant-btn-ghost{
    color: #fff;
    border: 1px solid #fff;
  }
  .ant-popover-message-title{
    color: rgba(0, 0, 0, 0.75);
  }


  .login-box{
    padding: 1rem;
    
  }
  .login-box .title{
    font-size: 18px;
    margin-bottom: 2rem;
    color: #111;
    text-align: center;
  }
  .login-modal .ant-modal-content{
    box-shadow: 0px 0px 0px 6px rgba(79, 70, 187, 0.6);
  }

  .login-modal .reg-success-box{
    text-align: center;

  }
  .login-modal .reg-success-box img{
    height: 100px;
  }
  .login-modal .reg-success-box .reg-title{
    font-size: 16px;
    color: #000;
  }
  .login-modal .reg-success-box .reg-desc{
    margin-bottom: 1rem;
  }
  .login-modal .reg-tips{
    font-size: 12px;
    line-height: normal;
    padding: 5px 15px 0 15px;
  }
</style>
